export class ValidationChecker {

  public static checkAllValidation(self: any) {
    if (ValidationChecker.checkPasswordAlphabet(self.newPassword)) {
      self.error = self.$t("message.passwordMustHaveUppercaseLetter");
      return false;
    }
    if (ValidationChecker.checkPasswordNumber(self.newPassword)) {
      self.error = self.$t("message.passwordMustHaveNum");
      return false;
    }
    if (ValidationChecker.checkPasswordLen(self.newPassword)) {
      self.error = self.$t("message.passwordMustHave8Chars");
      return false;
    }
    self.error = "";
    return true;
  }
  private static checkPasswordNumber(pwd: string) {
    return pwd.match(/[0-9]/) === null;
  }

  private static checkPasswordAlphabet(pwd: string) {
    return pwd.match(/[A-Z]/) === null;
  }

  private static checkPasswordLen(pwd: string) {
    return pwd.length < 8;
  }
}
